import { useEffect, useState } from 'react';

import { SITE_HOSTS } from '../utils/consts';

type HistoryState = Record<string, unknown> | null;

const CAME_FROM_SITE_FIELD = 'cameFromSite';

const readStoredVerdict = (state: HistoryState) => {
  const verdict = state?.[CAME_FROM_SITE_FIELD];
  return typeof verdict === 'boolean' ? verdict : undefined;
};

const isRouterEntry = (state: HistoryState) => typeof state?.key === 'string';

const hasPageToGoBackTo = () => window.history.length > 1;

const isSiteReferrer = () => {
  try {
    const { host } = new URL(document.referrer);
    return host === window.location.host || SITE_HOSTS.includes(host);
  } catch {
    return false;
  }
};

let landingEntryCameFromSite = false;
let isLandingEntryRecorded = false;

export const decideLandingEntry = () => {
  const { state } = window.history;
  landingEntryCameFromSite =
    readStoredVerdict(state) ??
    (isRouterEntry(state) || (isSiteReferrer() && hasPageToGoBackTo()));
};

export const recordLandingEntry = () => {
  if (isLandingEntryRecorded) return;
  isLandingEntryRecorded = true;
  window.history.replaceState(
    {
      ...window.history.state,
      [CAME_FROM_SITE_FIELD]: landingEntryCameFromSite,
    },
    '',
  );
};

export const useCameFromSite = () => {
  const [cameFromSite, setCameFromSite] = useState(false);

  useEffect(() => {
    const { state } = window.history;
    setCameFromSite(readStoredVerdict(state) ?? isRouterEntry(state));
  }, []);

  return cameFromSite;
};
